import * as React from 'react';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import {COMMON} from '../../../../../common/constants/LabelConstants';

class AssemblyCountryHelpView extends React.Component<{data: {message: string}}, {}> {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <div className="modal-info">
                    <div className="modal-scroll">
                        <div className="container text-center">
                            <img
                                className="py-3"
                                src={AssetsManager('/assets/images/common/about-question-faq-help-purple.svg')}/>
                            <h5 className="main-title pt-3">¿De dónde viene el vehículo que comprarás?</h5>
                            <p className="text-justify">El país de fabricación o ensamblaje se determina por el primer
                                carácter del VIN(Número de Identificación Vehicular). <br/>
                                Ejemplos: “3” = México, “1,4,5” = EE.UU., “J” = Japón, “2“ = Canadá, “K“ = Corea, “W“ =
                                Alemania, “Z” = Italia. <br/>
                                Si no puedes revisar el VIN, puedes consultar la factura emitida.</p>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default AssemblyCountryHelpView;
